module.exports = __webpack_public_path__ + "static/media/logo.453b6ead.svg";